import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { useIntl } from 'react-intl';
import styles from './style.module.scss';
import { Button } from '@wealth-common-ui-packages/button';
import { changeLocale } from 'approot/redux/sessionAction';
import { LONG_LOCALES } from './constant';
import { IconMenu } from '@piggybank/core';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import { getCookie } from 'approot/common/lib/CommonUtil';
import store from '../../app/store';
import ObjectHelper from 'approot/common/lib/ObjectHelper';


const Header =
	({ isMenuOpen, open }) => {
		const resolveAsset = (asset) => (asset && asset.default) ? asset.default : asset;
		const [isCookieHandled, setCookieHandled] = useState(false);
		const [isSelectedValue, setSelectedValue] = useState('en');
		useEffect(() => {
			document.documentElement.lang = isSelectedValue;
		}, [isSelectedValue]);	
		const dispatch = useDispatch();
		const { formatMessage: f } = useIntl();
		const languageOption = [];
		const { session } = store.getState();
		LONG_LOCALES.forEach((item) => {
			languageOption.push({ label: item.title, value: item.locale });
		});

		const navToPib = () => {
			window.location.href = process.env.REACT_APP_GSP_DASHBOARD_PAGE_LIN;
		};
		const triggerChangeOnMatch = (valueToMatch) => {
			//console.log('valueToMatch'+valueToMatch)
			const selectElement = document.querySelector(`.${styles.languageSelect}`);
			//console.log('selectElement'+selectElement)
			if (selectElement) {
				const matchingOption = Array.from(selectElement.options).find(option => option.value === valueToMatch);
				//console.log('matchingOption'+matchingOption)
				if (matchingOption) {
					selectElement.selectedIndex = Array.from(selectElement.options).indexOf(matchingOption);
					const event = new Event('change');
					matchingOption.dispatchEvent(event);
					dispatch(changeLocale(valueToMatch));
				}
			}
		};
		let cookieValue = '';
		
		try {
			cookieValue = getCookie('HSBC_CLIENT_COOKIE');
			console.log('updated cookie'+cookieValue);
			if(!ObjectHelper.isNullOrlengthZore(session.localStr) && !isCookieHandled) {
				triggerChangeOnMatch(session.localStr);
			}
			if (cookieValue&&ObjectHelper.isNullOrlengthZore(session.localStr)) {
				const extractedValue = cookieValue.split('%3D')[1];
				let formattedValue='';
				if (extractedValue === 'en_HK') {
					formattedValue = 'en-US';
				} else {
					formattedValue = extractedValue.replace(/_/g, '-');
				}
				if (!isCookieHandled) {
					triggerChangeOnMatch(formattedValue);
				}
			} else {
				console.log('No cookie found or cookie value is empty Header.');
			}
		} catch (error) {
			console.error('HSBC_CLIENT_COOKIE-HEADER error occurred:', error);
		}
		return (
			<header>
				<div className={styles.doormate}>
					<div className={styles.left} id='iconMenu'>
						{/* <div className={styles.hamburger} role='button' onClick={isMenuOpen} tabIndex={0} aria-expanded={open} aria-label={f({ id: 'ESG.questionnaire.header.menu' })}> */}
						<div className={styles.hamburger}>
							<IconButton
								color='inherit'
								aria-label={f({ id: 'ESG.questionnaire.header.menu' })}
								aria-expanded={open}
								onClick={isMenuOpen}
								edge='start'
								size='small'
								sx={[
									{	
										mr: 1
									}
								]}
							>
								<IconMenu />
							</IconButton>
						</div>
						{/* </div> */}
						<div role='icon'>
							<img className={styles.brandLogo} src={resolveAsset(require('approot/common/images/hsbc-logo.png'))} role={'graphic'} alt={f({ id: 'hsbc_logo' })} />
						</div>
					</div>
					<div className={styles.right}>
						<select
							aria-label={f({ id: 'ESG.questionnaire.header.languages' })}
							className={styles.languageSelect}
							onChange={(event) => {
								/* istanbul ignore else */
								if (!isCookieHandled) {
									setCookieHandled(true);
								}
								const selectedValue = event.target.value;
								setSelectedValue(event.target.value.replace(/-/g, '_'));
								dispatch(changeLocale(selectedValue));
								const currentDate = new Date();
								const expirationDate = new Date(currentDate.getTime() + 5 * 60 * 1000);
								let formatValue='';
								if (selectedValue === 'en-US') {
									formatValue = 'en_HK';
								} else {
									formatValue = selectedValue.replace(/-/g, '_');
								}
								document.cookie = `HSBC_CLIENT_COOKIE=PreferredLocale%3D${formatValue};domain=.hsbc.com.hk; expires=${expirationDate.toUTCString()}; path=/`;
							}}
							onKeyDown={(event) => { dispatch(changeLocale(event.target.value)); }}>
							{languageOption.map((item) => (
								<option key={item.value} value={item.value}>{item.label}</option>
							))}
						</select>
						<div className={styles.inlineDisplay}>
							<Button onClick={navToPib} kind={'secondary'} size={'small'}>
								{f({ id: 'Internet_banking' })}
							</Button>
						</div>
					</div>
				</div>
				<Divider aria-hidden={true} />
			</header>
		);
	};

Header.propTypes = {
	isMenuOpen: PropTypes.func,
	open: PropTypes.bool
};

export default Header;
